export const theme = {
    main: {
      bg: '#2b2b2b',
      text: '#fff',
      hover: '#fff36a', // yellow
      maxWidth: '60'
    },
    secondary: {
    	bg: '#2662bb', // blue
    	bg2: '#3478de', // alt blue
      bg3: '#ff486a', // red
      bg4: '#7a48bb' // purple
    },
    admin: {
      black: '#2b2b2b',
      white: '#fff',
      primary: '#3478de',
      info: '#2662bb',
      success: '#39dd6b',
      warning: '#fff36a',
      danger: '#ff486a'
    }
};


// WEBPACK FOOTER //
// /opt/build/repo/src/theme.js